import {Affiliate, CodeAvailability, FinalPayout, SocialPlatform, Status} from '../../shared/types';
import {InfluencerState} from '../reducers/influencer.reducer';
import {safelyToJS} from './utils';

export const selectAffiliateFinalPayout = (state): FinalPayout =>
    safelyToJS(state.getIn(['influencer', 'finalPayout']));

export const selectAffiliate = (state): Affiliate =>
    safelyToJS(state.getIn(['influencer', 'affiliateAccount']));

export const selectAffiliateStatus = (state): Status =>
    state.getIn(['influencer', 'affiliateAccount', 'status']);

export const selectAffiliateId = (state): string =>
    state.getIn(['influencer', 'affiliateAccount', 'id']);

export const selectAffiliateLoading = (state): boolean => state.getIn(['influencer', 'loading']);

export const selectCodeAvailability = (state): CodeAvailability & {loading: boolean} =>
    safelyToJS(state.getIn(['influencer', 'codeAvailability']));

export const selectInfluencer = (state): InfluencerState => safelyToJS(state.get('influencer'));

export const selectDisconnectedPlatform = (state): SocialPlatform =>
    state.getIn(['influencer', 'disconnectedPlatform']);

export const selectLastSocialUpdate = (state): string =>
    state.getIn(['influencer', 'lastSocialUpdate']);
